// extracted by mini-css-extract-plugin
export var skipAnimation = "_35-0";